"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcFabMenuConstants = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var BcFabMenuConstants = (function () {
    function BcFabMenuConstants() {
    }
    BcFabMenuConstants.NO_SCROLL = 'no-scroll';
    BcFabMenuConstants.BC_ICON = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-icon");
    BcFabMenuConstants.BC_FAB_MENU = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-fabmenu");
    BcFabMenuConstants.BC_FAB_MENU_ACTIVE = "".concat(BcFabMenuConstants.BC_FAB_MENU, "-active");
    BcFabMenuConstants.BC_FAB_MENU_BUTTON = "".concat(BcFabMenuConstants.BC_FAB_MENU, "-button");
    BcFabMenuConstants.BC_FAB_MENU_POSITION = "".concat(BcFabMenuConstants.BC_FAB_MENU, "-position");
    BcFabMenuConstants.BC_FAB_MENU_BACKDROP = "".concat(BcFabMenuConstants.BC_FAB_MENU, "-backdrop");
    BcFabMenuConstants.BC_FAB_MENU_BACKDROP_ACTIVE = "".concat(BcFabMenuConstants.BC_FAB_MENU, "-backdrop-active");
    BcFabMenuConstants.BC_ICON_BUTTON_SELECTED = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-icon-button-selected");
    BcFabMenuConstants.BC_FAB_MENU_ACTIONS_BUTTON = "".concat(BcFabMenuConstants.BC_FAB_MENU, "-action-buttons");
    BcFabMenuConstants.BC_ACTION_TEXT = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-action-text");
    BcFabMenuConstants.BC_FAB_MENU_ACTIONS_BUTTON_ACTIVE = "".concat(BcFabMenuConstants.BC_FAB_MENU, "-action-buttons-active");
    return BcFabMenuConstants;
}());
exports.BcFabMenuConstants = BcFabMenuConstants;
;
